import React from 'react';
import './BalanceDisplay.css';

function BalanceDisplay({ balance, loading }) {
  if (loading) {
    return (
      <div className="balance-display loading">
        <h3>Account Balance</h3>
        <div className="loading-skeleton">Loading...</div>
      </div>
    );
  }

  if (!balance || balance.length === 0) {
    return (
      <div className="balance-display">
        <h3>Account Balance</h3>
        <p className="no-balance">No balance information available</p>
      </div>
    );
  }

  return (
    <div className="balance-display">
      <h3>Account Balance</h3>
      <div className="balance-grid">
        {balance.map((item, index) => (
          <div key={index} className="balance-card">
            <div className="amounts">
              <div className="balance-item">
                <span className="label">Balance:</span>
                <span className="value">{formatAmount(item.balance)} {item.currency}</span>
              </div>
            </div>
            <div className="amounts">
              <div className="balance-item">
                <span className="label">Available:</span>
                <span className="value">{formatAmount(item.realBalance)} {item.currency}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function formatAmount(amount) {
  if (amount === undefined || amount === null) return '0.00';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}

export default BalanceDisplay;